export default number => (
  Math.round((number * 10) / 10)
);
